import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';
//import { BrowserRouter as Router, Switch, Route, HashRouter } from 'react-router-dom';
import Login from './components/login';
import BarBase from './components/barBase';
import Tutorial from './components/tutorial';
import Stats from './components/stats';
import Nav from './components/nav';
import blunderbomb from './images/blunderbomb.png';
import chainshot from './images/chainshot.png';
import coconut from './images/coconut.png';
import curseball from './images/curseball.png';
import firebomb from './images/firebomb.png';
import mango from './images/mango.png';
import meat from './images/meat2.png';
import pineapple from './images/pineapple.png';
import pom from './images/pom.png';
import blunderbuss from './images/blunderbuss.png';
import eor from './images/eor.png';
import keg from './images/keg.png';
import reroll from './images/reroll.png';
import rowboat from './images/rowboat.png';
import sword from './images/sword.png';
import worms from './images/worms.png';
import blunderbuss_alone from './images/blunderbuss_alone.png';
import eor_alone from './images/eor_alone.png';
import sword_alone from './images/sword_alone.png';
import coconut_alone from './images/coconut_alone.png';
import pom_alone from './images/pom_alone.png';
import mango_alone from './images/mango_alone.png';
import pineapple_alone from './images/pineapple_alone.png';
import meat_alone from './images/meat_alone.png';
import worms_alone from './images/worms_alone.png';
import blunderbomb_alone from './images/blunderbomb_alone.png';
import chainshot_alone from './images/chainshot_alone.png';
import curseball_alone from './images/curseball_alone.png';
import firebomb_alone from './images/firebomb_alone.png';
import reroll_alone from './images/reroll_alone.png';
import parchment from './images/parchment.png';
import parchmentStreamer from './images/parchment6.png';
import parchmentClosed from './images/parchmentClosed.png';
import parchmentClosedStreamer from './images/parchmentClosed_Streamer.png';
import paperUnfoldAudio from './audio/paper_unfold.mp3'
import paperFoldAudio from './audio/paper_fold.mp3'
import crossout1Audio from './audio/crossout1.mp3'
import crossout2Audio from './audio/crossout2.mp3'
import crossout3Audio from './audio/crossout3.mp3'
import coins1Audio from './audio/coins1.mp3'
import coins2Audio from './audio/coins2.mp3'
import coins3Audio from './audio/coins3.mp3'
import bubble1Audio from './audio/bubble1.mp3'
import bubble2Audio from './audio/bubble2.mp3'
import bubble3Audio from './audio/bubble3.mp3'
import endAudio from './audio/wanted.mp3'
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';

const PAGES = {
  LOGIN: "LOGIN",
  TUTORIAL: "TUTORIAL",
  BARBASE: "BARBASE",
  STATS: "STATS"
};

const INITIAL_PAGE = PAGES.LOGIN;

/*var fs, scaleFactor, monitorWidth, monitorHeight, widthFactor, heightFactor;
window.$ = $;
if (window.api?.isElectron) {
  fs = window.api.fs;
  let text = fs.readFileSync('scaleFactor.txt', 'utf-8').split('\n');
  scaleFactor = parseFloat(text[0]);
  monitorWidth = parseInt(text[1]);
  monitorHeight = parseInt(text[2]);
}
widthFactor = monitorWidth / 3840;
heightFactor = monitorHeight / 2160;

console.log(scaleFactor);
console.log(widthFactor);
console.log(heightFactor);*/


const width = 680;//window.api?.isElectron ? Math.round(680 / widthFactor) : 680;
const heightLg = 720;//window.api?.isElectron ? Math.round(720 / heightFactor) : 720;
const heightSm = 50;//window.api?.isElectron ? Math.round(50 / heightFactor) : 50;
/*const width = window.api?.isElectron ? Math.round(1020 / scaleFactor) : 1020;
const heightLg = window.api?.isElectron ? Math.round(1080 / scaleFactor) : 1080;
const heightSm = window.api?.isElectron ? Math.round(75 / scaleFactor) : 75;*/

const challengesT1 = [
  "Kill an enemy player",
  "Sleep in an enemy crew's bed",
  "Ring enemy ship's crow's nest bell",
  "Use a trident to kill an enemy player",
  "Eat all of an enemy crew's bananas",
  "Put a banana on enemy crew's stove",
  "Drop an enemy crew's anchor"
];
const challengesT2 = [
  "One-ball an enemy player",
  "Ram an enemy boat with another enemy's boat",
  "Convince enemy crew to willingly give a piece of loot",
  "Use a keg on an enemy ship",
  "Play music with an enemy crew then kill at least 1",
  "Tuck near enemy players for 30 seconds successfully",
  "Vomit on an enemy player",
  "Place piece of loot on bow of enemy ship",
  "Draw a shape on an enemy crew's map"
];
const challengesT3 = [
  "Deckshot onto an enemy ship",
  "Harpoon an enemy player off their ship",
  "Land 10 consecutive cannonballs on an enemy ship",
  "Toss all an enemy crew's planks overboard using crates",
  "Tuck in plain sight of enemy players for 1 min",
  "Keg an enemy ship without dying",
  "Hit an enemy ship with a cannonball from max range",
  "Convince enemy player to firebomb their own boat",
  "Convince enemy player to toss piece of loot overboard"
];

const pistolChallengesT1 = [
  "While in midair, land pistol shot on enemy player"
];

const pistolChallengesT2 = [
  "Hit an enemy player with pistol hip fire",
  "Hit an enemy player with pistol while swimming"
];

const pistolChallengesT3 = [
  "Hit an enemy ship-to-ship with pistol"
];

const swordChallengesT1 = [
  "Kill enemy with a sword lunge"
];

const swordChallengesT2 = [
  "Sword lunge jump onto an enemy ship",
  "Block a 3-hit combo with sword",
  "Dodge an incoming weapon shot using sword hops"
];

const swordChallengesT3 = [
  "Hit 2 or more enemies with a single sword lunge"
];

const blunderChallengesT1 = [
  "Kill enemy with a 1-blunder"
];

const blunderChallengesT2 = [
  "Kill an enemy player with blunderbuss at range"
];

const blunderChallengesT3 = [
  "Knock enemy off ship with blunderbuss"
];

const eyeOfReachChallengesT1 = [
  "Quickscope an enemy player with EoR"
];

const eyeOfReachChallengesT2 = [
  "Hit enemy player with EoR hip fire",
  "Hit an enemy player with EoR while swimming"
];

const eyeOfReachChallengesT3 = [
  "Snipe enemy ship-to-ship with EoR"
];

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: INITIAL_PAGE,
      username: "",
      crewSize: 1,
      streamerMode: false,
      muteAudio: false,
      loggedIn: false,
      silver: 2000,
      totalSilver: 2000,
      challengeT1: challengesT1[this.rand(0, challengesT1.length)],
      challengeT2: challengesT2[this.rand(0, challengesT2.length)],
      challengeT3: challengesT3[this.rand(0, challengesT3.length)],
      challengeT1Checked: false,
      challengeT2Checked: false,
      challengeT3Checked: false,
      challengesCompleted: 0,
      shipsSunk: 0,
      upgrades: [
          { id: "1", name: "Blunderbuss", price: 10000, amount: 0, oneTimeUse: true, disabled: false, image: blunderbuss, image2: blunderbuss_alone, emoji: "🔫" },
          { id: "2", name: "Eye of reach", price: 15000, amount: 0, oneTimeUse: true, disabled: false, image: eor, image2: eor_alone, emoji: "🔫" },
          { id: "3", name: "Sword", price: 20000, amount: 0, oneTimeUse: true, disabled: false, image: sword, image2: sword_alone, emoji: "🗡️" },
          { id: "4", name: "Coconuts", price: 2000, amount: 0, oneTimeUse: true, disabled: false, image: coconut, image2: coconut_alone, emoji: "🥥" },
          { id: "5", name: "Pomegranates", price: 3000, amount: 0, oneTimeUse: true, disabled: false, image: pom, image2: pom_alone, emoji: "🍅" },
          { id: "6", name: "Mangos", price: 4000, amount: 0, oneTimeUse: true, disabled: false, image: mango, image2: mango_alone, emoji: "🥭" },
          { id: "7", name: "Pineapples", price: 5000, amount: 0, oneTimeUse: true, disabled: false, image: pineapple, image2: pineapple_alone, emoji: "🍍" },
          { id: "8", name: "Meats", price: 5000, amount: 0, oneTimeUse: true, disabled: false, image: meat, image2: meat_alone, emoji: "🍗" },
          { id: "9", name: "Worms", price: 3000, amount: 0, oneTimeUse: true, disabled: false, image: worms, image2: worms_alone, emoji: "🪱" }
      ],
      items: [
          { id: "10", name: "Blunderbomb", price: 300, amount: 0, oneTimeUse: false, disabled: false, image: blunderbomb, image2: blunderbomb_alone, emoji: "💣" },
          { id: "11", name: "Firebomb", price: 100, amount: 0, oneTimeUse: false, disabled: false, image: firebomb, image2: firebomb_alone, emoji: "🔥" },
          { id: "12", name: "Curseball", price: 500, amount: 0, oneTimeUse: false, disabled: false, image: curseball, image2: curseball_alone, emoji: "🔮" },
          { id: "13", name: "Chainshot", price: 1000, amount: 0, oneTimeUse: false, disabled: false, image: chainshot, image2: chainshot_alone, emoji: "⛓️" },
          //{ id: "7", name: "Reroll challenges", price: 10000, amount: 0, oneTimeUse: false, disabled: false, image: reroll, image2: reroll_alone, emoji: "🎲" }
      ]
    }
  }

  pageIs = (page) => this.state.currentPage === page;
  backgroundSize = `${window.innerWidth}px ${window.innerHeight}px`;
  lastAudio = "";
  audioObj = new Audio();

  chromaStyle = {
    height: `${this.isMobile() ? 'auto' : '2560px'}`
  };

  navWidthStyle = {
    width: this.getCalculatedWidth()
  }

  webNavStyle = {
  }

  mobileStyle = {
    height: this.isMobile() ? '100%' : 'auto'
  }

  backgroundStyle = {
    backgroundSize:     this.getBackgroundSize(),
    backgroundRepeat:   "no-repeat",  
    backgroundPosition: window.api?.isElectron ? "auto" : `center top${this.isMobile() ? "" : " 56px"}`,
    backgroundAttachment: "fixed",
    height: `${this.isMobile() ? '100%' : 'auto'}`
    //width: window.innerWidth/scaleFactor,
    //height: window.innerHeight/scaleFactor
  };

  getCalculatedWidth() {
    let widthSize;
    let width = 1020;
    let height = 1080;
    if (!this.isWeb() && this.isMobile())
      widthSize = `${window.screen.width}px`;
    else if (this.isWeb() && this.isMobile())
      widthSize = `${width * (window.innerHeight/height)}px`;
    else {
      let screenHeight = window.innerHeight - 56 + (window.screen.height <= 1080 ? this.getTaskbarSize() : 0);
      let screenWidth = window.innerWidth;
      if (screenHeight < 1080)
        width = screenHeight * (width/height);
      if (screenWidth < 1020)
        width = screenWidth;
        widthSize = `${width}px`;// ${window.screen.height * window.devicePixelRatio}px`;
    }

    return widthSize;
  }

  getTaskbarSize() {
    return window.screen.height - window.screen.availHeight;
  }

  getBackgroundSize() {
    let bgSize;
    if (this.isMobile())
      bgSize = "auto 100%";
    else if (window.api?.isElectron)
      bgSize = `${window.innerWidth}px ${window.innerHeight}px`;
    else {
      let width = 1020;
      let height = 1080;
      let screenHeight = window.innerHeight - 56 + (window.screen.height <= 1080 ? this.getTaskbarSize() : 0);
      let screenWidth = window.innerWidth;
      if (screenHeight < 1080)
        width = screenHeight * (width/height);
      if (screenWidth < 1020)
        width = screenWidth;
      bgSize = `${width}px`;// ${window.screen.height * window.devicePixelRatio}px`;
    }

    return bgSize;
  }
  
  isMobile() {
    if (window.api?.isElectron)
      return false;
    if (window.screen.height < 864)//this.getCalculatedWidth() < 831 && !nav)//884
      return true;
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  isWeb() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return !check && !window.api?.isElectron;
  }

  getT1Challenges() {
    let challenges = challengesT1.concat(pistolChallengesT1);

    if (this.state.upgrades.find(x => x.name == "Sword").disabled)
      challenges = challenges.concat(swordChallengesT1);
    if (this.state.upgrades.find(x => x.name == "Blunderbuss").disabled)
      challenges = challenges.concat(blunderChallengesT1);
    if (this.state.upgrades.find(x => x.name == "Eye of reach").disabled)
      challenges = challenges.concat(eyeOfReachChallengesT1);

    return challenges;
  }

  getT2Challenges() {
    let challenges = challengesT2.concat(pistolChallengesT2);

    if (this.state.upgrades.find(x => x.name == "Sword").disabled)
      challenges = challenges.concat(swordChallengesT2);
    if (this.state.upgrades.find(x => x.name == "Blunderbuss").disabled)
      challenges = challenges.concat(blunderChallengesT2);
    if (this.state.upgrades.find(x => x.name == "Eye of reach").disabled)
      challenges = challenges.concat(eyeOfReachChallengesT2);

    return challenges;
  }

  getT3Challenges() {
    let challenges = challengesT3.concat(pistolChallengesT3);

    if (this.state.upgrades.find(x => x.name == "Sword").disabled)
      challenges = challenges.concat(swordChallengesT3);
    if (this.state.upgrades.find(x => x.name == "Blunderbuss").disabled)
      challenges = challenges.concat(blunderChallengesT3);
    if (this.state.upgrades.find(x => x.name == "Eye of reach").disabled)
      challenges = challenges.concat(eyeOfReachChallengesT3);

    return challenges;
  }

  handleUsernameChange = (event) => {
    this.setState({ username: event.target.value });
  }

  handleCrewSizeChange = (event) => {
      this.setState({ crewSize: parseInt(event.target.value) });
  }

  handleStreamerModeChange = (event) => {
      this.setState({ streamerMode: event.target.checked });
  }

  handleMuteChange = (event) => {
      this.setState({ muteAudio: event.target.checked });
  }

  handleLoggedIn() {
    this.setState({ loggedIn: true });
  }

  handleLoggedOut () {
    this.setState({ loggedIn: false });
  }

  rand(floor, ceiling) {
    return Math.floor(Math.random() * ceiling) + floor;
  }

  resetChallenges() {
    let prevChallenge = this.state.challengeT1.slice();
    let challengeT1 = prevChallenge;
    let challengesT1 = this.getT1Challenges();
    while (prevChallenge == challengeT1)
        challengeT1 = challengesT1[this.rand(0, challengesT1.length)];

    prevChallenge = this.state.challengeT2.slice();
    let challengeT2 = prevChallenge;
    let challengesT2 = this.getT2Challenges();
    while (prevChallenge == challengeT2)
        challengeT2 = challengesT2[this.rand(0, challengesT2.length)];

    prevChallenge = this.state.challengeT3.slice();
    let challengeT3 = prevChallenge;
    let challengesT3 = this.getT3Challenges();
    while (prevChallenge == challengeT3)
        challengeT3 = challengesT3[this.rand(0, challengesT3.length)];

    $('#challengeT1Check').prop('checked', false);
    $('#challengeT2Check').prop('checked', false);
    $('#challengeT3Check').prop('checked', false);
    $('#challengeSlide1').removeClass("opacity-50 strikethrough");
    $('#challengeSlide2').removeClass("opacity-50 strikethrough");
    $('#challengeSlide3').removeClass("opacity-50 strikethrough");
    this.setState({ challengeT1: challengeT1, challengeT2: challengeT2, challengeT3: challengeT3, challengeT1Checked: false, challengeT2Checked: false, challengeT3Checked: false });
}

  rerollChallenges(item) {
      this.resetChallenges();
      this.setState({ silver: this.state.silver - item.price });
  }

    handlePurchase = (item) => {
        let silver = this.state.silver;
        if (silver < item.price || item.disabled) {
          /*let itemHeight = $(`#${item.id}`).position().top;
          let itemId = item.id.toString() + item.amount.toString();
          $(`<p id="popUpX${itemId}" class="popX merchant">X</p>`).appendTo($(`#${item.id}`).parent());
          $(`#popUpX${itemId}`).animate({
            top: itemHeight - 50,
            opacity: 0 
          }, 1000,"linear",
              function() {
          $(this).remove();
          });*/

          return;
        }
        if (item.oneTimeUse)
            item.disabled = true;
        else {
          let itemHeight = $(`#${item.id}`).position().top;
          let itemId = item.id.toString() + item.amount.toString();
          $(`<p id="plus${itemId}" class="plus-one merchant">+1</p>`).appendTo($(`#${item.id}`).parent());
          $(`#plus${itemId}`).animate({
            top: itemHeight - 50,
            opacity: 0 
          }, 1000,"linear",
              function() {
          $(this).remove();
          });
        }
        item.amount++;
        console.log("Purchase Event Handler Called");
        if (item.name.toLowerCase() == "reroll challenges")
            this.rerollChallenges(item);
        else
            this.setState({ silver: this.state.silver - item.price });
        this.playAudio("coins");
    };

    handleT1Challenge = () => {
        this.setState({ silver: this.state.silver + 1000, totalSilver: this.state.totalSilver + 1000, challengesCompleted: this.state.challengesCompleted + 1, challengeT1Checked: true });
        $('#challengeSlide1').addClass("opacity-50 strikethrough");
        this.playAudio("crossout");
        /*let challenge1 = this.state.challengeT1.slice();
        let challenge2 = challenge1;
        while (challenge1 == challenge2) {
            challenge2 = challengesT1[this.rand(0, challengesT1.length)];
            this.setState({ silver: this.state.silver + 1000, challengeT1: challenge2, challengesCompleted: this.state.challengesCompleted + 1 });
        }
        $('#challengeT1Check').prop('checked', false);*/
    };

    handleT2Challenge = () => {
        this.setState({ silver: this.state.silver + 2500, totalSilver: this.state.totalSilver + 2500, challengesCompleted: this.state.challengesCompleted + 1, challengeT2Checked: true });
        $('#challengeSlide2').addClass("opacity-50 strikethrough");
        this.playAudio("crossout");
        /*let challenge1 = this.state.challengeT2.slice();
        let challenge2 = challenge1;
        while (challenge1 == challenge2) {
            challenge2 = challengesT2[this.rand(0, challengesT2.length)];
            this.setState({ silver: this.state.silver + 2500, challengeT2: challenge2, challengesCompleted: this.state.challengesCompleted + 1 });
        }
        $('#challengeT2Check').prop('checked', false);*/
    };

    handleT3Challenge = () => {
        this.setState({ silver: this.state.silver + 5000, totalSilver: this.state.totalSilver + 5000, challengesCompleted: this.state.challengesCompleted + 1, challengeT3Checked: true });
        $('#challengeSlide3').addClass("opacity-50 strikethrough");
        this.playAudio("crossout");
        /*let challenge1 = this.state.challengeT3.slice();
        let challenge2 = challenge1;
        while (challenge1 == challenge2) {
            challenge2 = challengesT3[this.rand(0, challengesT3.length)];
            this.setState({ silver: this.state.silver + 5000, challengeT3: challenge2, challengesCompleted: this.state.challengesCompleted + 1 });
        }
        $('#challengeT3Check').prop('checked', false);*/
    };

    handleAddSink = () => {
      let itemHeight = $('#sinkBtn').position().top;
      $(`<p id="plusSunk${this.state.shipsSunk}" class="plus-sunk merchant">+1</p>`).appendTo($('#sinkBtn'));
      $(`#plusSunk${this.state.shipsSunk}`).animate({
        top: itemHeight - 50,
        opacity: 0 
      }, 1000,"linear",
          function() {
      $(this).remove();
      });
      this.playAudio("bubble");
        this.resetChallenges();
        let price = 10000;
        switch(this.state.crewSize) {
          case 1:
            price = 10000;
            break;
          case 2:
            price = 8000;
            break;
          break;
          case 3:
            price = 6500;
            break;
          break;
          case 4:
            price = 5000;
            break;
        }
        this.setState({ silver: this.state.silver + price, totalSilver: this.state.totalSilver + price, shipsSunk: this.state.shipsSunk + 1});
    };

    handleEndSession() {
      this.setState({ 
        currentPage: INITIAL_PAGE,
        username: this.state.username,
        crewSize: this.state.crewSize,
        streamerMode: this.state.streamerMode,
        muteAudio: this.state.muteAudio,
        loggedIn: false,
        silver: 2000,
        totalSilver: 2000,
        challengeT1: challengesT1[this.rand(0, challengesT1.length)],
        challengeT2: challengesT2[this.rand(0, challengesT2.length)],
        challengeT3: challengesT3[this.rand(0, challengesT3.length)],
        challengeT1Checked: false,
        challengeT2Checked: false,
        challengeT3Checked: false,
        challengesCompleted: 0,
        shipsSunk: 0,
        upgrades: [
          { id: "1", name: "Blunderbuss", price: 10000, amount: 0, oneTimeUse: true, disabled: false, image: blunderbuss, image2: blunderbuss_alone, emoji: "💥🔫" },
          { id: "2", name: "Eye of reach", price: 15000, amount: 0, oneTimeUse: true, disabled: false, image: eor, image2: eor_alone, emoji: "🔭🔫" },
          { id: "3", name: "Sword", price: 20000, amount: 0, oneTimeUse: true, disabled: false, image: sword, image2: sword_alone, emoji: "🗡️" },
          { id: "4", name: "Coconuts", price: 2000, amount: 0, oneTimeUse: true, disabled: false, image: coconut, image2: coconut_alone, emoji: "🥥" },
          { id: "5", name: "Pomegranates", price: 3000, amount: 0, oneTimeUse: true, disabled: false, image: pom, image2: pom_alone, emoji: "🍅" },
          { id: "6", name: "Mangos", price: 4000, amount: 0, oneTimeUse: true, disabled: false, image: mango, image2: mango_alone, emoji: "🥭" },
          { id: "7", name: "Pineapples", price: 5000, amount: 0, oneTimeUse: true, disabled: false, image: pineapple, image2: pineapple_alone, emoji: "🍍" },
          { id: "8", name: "Meats", price: 5000, amount: 0, oneTimeUse: true, disabled: false, image: meat, image2: meat_alone, emoji: "🍗" },
          { id: "9", name: "Worms", price: 3000, amount: 0, oneTimeUse: true, disabled: false, image: worms, image2: worms_alone, emoji: "🪱" }
      ],
      items: [
          { id: "10", name: "Blunderbomb", price: 300, amount: 0, oneTimeUse: false, disabled: false, image: blunderbomb, image2: blunderbomb_alone, emoji: "💣" },
          { id: "11", name: "Firebomb", price: 100, amount: 0, oneTimeUse: false, disabled: false, image: firebomb, image2: firebomb_alone, emoji: "🔥" },
          { id: "12", name: "Curseball", price: 500, amount: 0, oneTimeUse: false, disabled: false, image: curseball, image2: curseball_alone, emoji: "🔮" },
          { id: "13", name: "Chainshot", price: 1000, amount: 0, oneTimeUse: false, disabled: false, image: chainshot, image2: chainshot_alone, emoji: "⛓️" },
          //{ id: "7", name: "Reroll challenges", price: 10000, amount: 0, oneTimeUse: false, disabled: false, image: reroll, image2: reroll_alone, emoji: "🎲" }
        ]});
        $('#challengeT1Check').prop('checked', false);
        $('#challengeT2Check').prop('checked', false);
        $('#challengeT3Check').prop('checked', false);
        $('#challengeSlide1').removeClass("opacity-50 strikethrough");
        $('#challengeSlide2').removeClass("opacity-50 strikethrough");
        $('#challengeSlide3').removeClass("opacity-50 strikethrough");
    };

    handleNavClick = () => {
      if (this.isMobile())
        return;
      console.log($('#collapseBtn').attr("aria-expanded"));
      let parchmentClass = this.state.streamerMode ? "parchmentStreamer" : "parchment";
      let parchmentClosedClass = this.state.streamerMode ? "parchmentClosedStreamer" : "parchmentClosed";
      if ($('#collapseBtn').attr("aria-expanded") == "false")  {
        this.playAudio("paperFold");
        setTimeout(function (){
          window.resizeTo(width, heightSm);
          $('#back').removeClass(parchmentClass);
          $('#back').addClass(parchmentClosedClass);
          //$('#collapseTarget').attr('hidden', true);
        }, 500);
      }
      else {
        this.playAudio("paperUnfold");
        //$('#collapseTarget').attr('hidden', false);
        $('#back').removeClass(parchmentClosedClass);
        $('#back').addClass(parchmentClass);
        window.resizeTo(width, heightLg);
      }
    }

    playAudio = (sound) => {
      if (this.state.muteAudio)
        return;
      if (sound == "crossout" || sound == "coins" || sound == "bubble") {
        let rand = Math.floor((Math.random() * 3) + 1);
        while (this.lastAudio.indexOf(sound + rand) != -1)
          rand = Math.floor((Math.random() * 3) + 1);
        this.lastAudio = sound + rand.toString();
        sound = sound + rand.toString();
      }

      switch (sound) {
        case "paperUnfold":
          this.audioObj.src = paperUnfoldAudio;
          break;
        case "paperFold":
          this.audioObj.src = paperFoldAudio;
          break;
        case "crossout1":
          this.audioObj.src = crossout1Audio;
          break;
        case "crossout2":
          this.audioObj.src = crossout2Audio;
          break;
        case "crossout3":
          this.audioObj.src = crossout3Audio;
          break;
        case "coins1":
          this.audioObj.src = coins1Audio;
          break;
        case "coins2":
          this.audioObj.src = coins2Audio;
          break;
        case "coins3":
          this.audioObj.src = coins3Audio;
          break;
        case "bubble1":
          this.audioObj.src = bubble1Audio;
          break;
        case "bubble2":
          this.audioObj.src = bubble2Audio;
          break;
        case "bubble3":
          this.audioObj.src = bubble3Audio;
          break;
        case "end":
          this.audioObj.src = endAudio;
          break;
      }

      this.audioObj.play();
    }

    isBoxy() {
        let name = this.state.username.replace(' ','').toLowerCase();
        return name == "boxy" || name == "boxyfresh";
    }

    onClickNextPage = (page) => () => {
      switch (page) {
        case PAGES.LOGIN:
        this.handleEndSession();
        break;
        case PAGES.BARBASE:
          this.handleLoggedIn();
          break;
        case PAGES.STATS:
          if (!this.isBoxy())
            this.playAudio("end");
          this.handleLoggedOut();
          break;
      }
      this.setState({currentPage: page});
    };

  componentDidMount() {
    if (this.isMobile())
      $('body').addClass('noScrollingX');
    else
      $('body').addClass('noScrolling');
  }

  render () {
    return (
      <div className={this.state.streamerMode ? "App backStreamer" : "App back"} style={this.chromaStyle}>
        <nav style={this.webNavStyle} hidden={!this.isWeb()} className="navbar navbar-expand-lg navbar-dark bg-dark merchant">
          <span className="navbar-brand mx-3" >Scurvy Scroll</span>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link" href="https://www.twitch.tv/blurbs" target="_blank">Twitch</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.youtube.com/blurbs" target="_blank">YouTube</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://discord.gg/zrSnf4JvKw" target="_blank">Discord</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://twitter.com/Blurbstv" target="_blank">Twitter</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://www.instagram.com/blurbsttv/" target="_blank">Instagram</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://twitter.com/Capi974" target="_blank">Artist</a>
              </li>
            </ul>
          </div>
          <ul className="navbar-nav mx-3">
            <li className="nav-item">
              <a className="nav-link navbar-text" href="https://objectstorage.us-ashburn-1.oraclecloud.com/n/idput4irvftn/b/scurvybucket/o/ScurvyScroll.zip" target="_blank"><span className="text-primary">DOWNLOAD</span> to use in-game</a>
            </li>
          </ul>
        </nav>
        <div id="back" className={this.state.streamerMode ? "parchmentStreamer" : "parchment"} style={this.backgroundStyle}>
          <button id="collapseBtn" style={this.navWidthStyle} className="btn shadow-none p-0 border-0" type="button" data-bs-toggle={this.isMobile() ? "" : "collapse"} data-bs-target="#collapseTarget" aria-expanded="true" aria-controls="collapseTarget" onClick={this.handleNavClick} >
            <Nav className="" loggedIn={this.state.loggedIn} silver={this.state.silver} challengeT1={this.state.challengeT1} challengeT2={this.state.challengeT2} challengeT3={this.state.challengeT3} challengeT1Checked={this.state.challengeT1Checked}
            challengeT2Checked={this.state.challengeT2Checked} challengeT3Checked={this.state.challengeT3Checked} upgrades={this.state.upgrades} items={this.state.items} streamerMode={this.state.streamerMode} isMobile={this.isMobile()} isWeb={this.isWeb()}/>
          </button >
          <div style={this.mobileStyle}>
            <div style={this.mobileStyle} className="collapse bg-transparent show" id="collapseTarget">
              {this.pageIs(PAGES.LOGIN) ? (
                <Login onClickNext={this.onClickNextPage(PAGES.TUTORIAL)} username={this.state.username} crewSize={this.state.crewSize} streamerMode={this.state.streamerMode} muteAudio={this.state.muteAudio} onUsernameChange={this.handleUsernameChange} onCrewSizeChange={this.handleCrewSizeChange}
                onStreamerModeChange={this.handleStreamerModeChange} onMuteChange={this.handleMuteChange} isMobile={this.isMobile()} isWeb={this.isWeb()} />
              ) : null}
              {this.pageIs(PAGES.TUTORIAL) ? (
                <Tutorial onClickNext={this.onClickNextPage(PAGES.BARBASE)} onStart={this.handleLoggedIn} isMobile={this.isMobile()} isWeb={this.isWeb()} />
              ) : null}
              {this.pageIs(PAGES.BARBASE) ? (
                <BarBase onClickNext={this.onClickNextPage(PAGES.STATS)} onAddSink={this.handleAddSink} onT1Challenge={this.handleT1Challenge} onT2Challenge={this.handleT2Challenge} onT3Challenge={this.handleT3Challenge} onPurchase={this.handlePurchase} 
                silver={this.state.silver} items={this.state.items} upgrades={this.state.upgrades} challengeT1={this.state.challengeT1} challengeT2={this.state.challengeT2} challengeT3={this.state.challengeT3}
                challengeT1Checked={this.state.challengeT1Checked} challengeT2Checked={this.state.challengeT2Checked} challengeT3Checked={this.state.challengeT3Checked} onLogOut={this.handleLoggedOut} isMobile={this.isMobile()} isWeb={this.isWeb()}/>
              ) : null}
              {this.pageIs(PAGES.STATS) ? (
                <Stats onClickNext={this.onClickNextPage(PAGES.LOGIN)} silver={this.state.silver} totalSilver={this.state.totalSilver} challengesCompleted={this.state.challengesCompleted} upgrades={this.state.upgrades} items={this.state.items} onEndSession={this.handleEndSession} 
                username={this.state.username} shipsSunk={this.state.shipsSunk} crewSize={this.state.crewSize} muteAudio={this.state.muteAudio} isMobile={this.isMobile()} isWeb={this.isWeb()} />
              ) : null}
                {/*<Route path="/" exact render={(props) => <Login {...props} username={this.state.username} crewSize={this.state.crewSize} streamerMode={this.state.streamerMode} muteAudio={this.state.muteAudio} onUsernameChange={this.handleUsernameChange} onCrewSizeChange={this.handleCrewSizeChange}
                  onStreamerModeChange={this.handleStreamerModeChange} onMuteChange={this.handleMuteChange} />}/>
                <Route path="/barBase" render={(props) => <BarBase {...props} onAddSink={this.handleAddSink} onT1Challenge={this.handleT1Challenge} onT2Challenge={this.handleT2Challenge} onT3Challenge={this.handleT3Challenge} onPurchase={this.handlePurchase} 
                  silver={this.state.silver} items={this.state.items} upgrades={this.state.upgrades} challengeT1={this.state.challengeT1} challengeT2={this.state.challengeT2} challengeT3={this.state.challengeT3}
                  challengeT1Checked={this.state.challengeT1Checked} challengeT2Checked={this.state.challengeT2Checked} challengeT3Checked={this.state.challengeT3Checked} onLogOut={this.handleLoggedOut}/>} />
                <Route path="/tutorial" render={(props) => <Tutorial {...props} onStart={this.handleLoggedIn} />}/>
                <Route path="/stats" render={(props) => <Stats {...props} silver={this.state.silver} totalSilver={this.state.totalSilver} challengesCompleted={this.state.challengesCompleted} upgrades={this.state.upgrades} items={this.state.items} onEndSession={this.handleEndSession} 
              username={this.state.username} shipsSunk={this.state.shipsSunk} crewSize={this.state.crewSize} muteAudio={this.state.muteAudio} />}/>*/}
            </div>
          </div>
        </div>
      </div>)
  };
}
export default App;

